module.exports = __webpack_public_path__ + "assets/img/my-vip-cont3.2dbb4c6d.png";